import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

const Waivers = () => {
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <SEOHead
        title="Rental Agreement & Waiver | Son's Guadalupe"
        description="Review and sign the Son's Guadalupe rental agreement and liability waiver before your visit. Required for all guests enjoying cabanas, tubing, and glamping."
        canonical="/waivers"
      />

      <Header />

      {/* Waiver Container - Full page iframe */}
      <main className="flex-1 w-full max-w-7xl mx-auto pt-32 lg:pt-40 pb-8 px-4">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-6 text-center">
          Rental Agreement & Waiver
        </h1>
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <iframe
            name="checkfront"
            className="CHECKFRONT_DROPLET"
            src="https://sonsguadalupe.checkfront.com/reserve/document/?template_id=1&return_url=%2Freserve%2Fdocuments%2Fdirectory%2F&kiosk=1/?inline=1&provider=droplet&pipe=https%3A%2F%2Fsonsguadalupe.checkfront.com%2Fmanage%2Fextend%2Fintegrate%2Fwidget%2Fdroplet%2Fpipe%2Fhelper.html&ssl=1&src=https%3A%2F%2Fsonsguadalupe.checkfront.com"
            style={{
              display: 'block',
              width: '100%',
              height: 'calc(100vh - 220px)',
              minHeight: '600px',
              border: 'none',
            }}
            title="Waiver Form"
          />
        </div>
        
        {/* Help text */}
        <p className="text-center text-charcoal/60 text-sm mt-4">
          Need help? Call{" "}
          <a href="tel:877-577-7667" className="text-teal font-medium hover:underline">
            877-577-7667
          </a>
          {" "}(9am-7pm Daily)
        </p>

        {/* SEO content */}
        <section className="mt-12 max-w-3xl mx-auto prose prose-lg text-foreground">
          <h2 className="font-heading text-2xl font-bold text-foreground">About the Son's Guadalupe Rental Agreement & Liability Waiver</h2>
          <p>
            Every guest visiting Son's Guadalupe in New Braunfels, Texas is required to read and sign our rental
            agreement and liability waiver before checking in. This includes everyone enjoying our private riverfront
            cabana rentals on the Guadalupe River, tubing the Guadalupe River, kayak rentals, glamping near New Braunfels,
            and tent camping on River Road. Signing in advance saves time at the front gate so you can get on the
            water faster on the day of your reservation.
          </p>

          <h3 className="font-heading text-xl font-bold text-foreground mt-8">Who Needs to Sign a Waiver?</h3>
          <p>
            All guests age 18 and older must sign the waiver for themselves. A parent or legal guardian must sign on
            behalf of any minors (under 18) in their party. If you booked a cabana, glamping tent, or tubing package
            for a group, every adult in your group should complete a waiver — not just the person who made the
            reservation. The form takes about two minutes per person and only needs to be signed once per visit.
          </p>

          <h3 className="font-heading text-xl font-bold text-foreground mt-8">What the Waiver Covers</h3>
          <p>
            The Son's Guadalupe waiver outlines the inherent risks of river-based recreation — tubing, kayaking,
            swimming, and wading on the Guadalupe River — and confirms that you understand and accept those risks.
            It also covers our property rules around glass containers (not allowed on the river), pets, parking,
            quiet hours for overnight glamping and tent camping guests, and proper use of cabanas, picnic tables,
            and shared facilities. We strongly recommend reviewing our cancellation policy and FAQs before signing
            so you know exactly what to expect on the day of your visit.
          </p>

          <h3 className="font-heading text-xl font-bold text-foreground mt-8">River Safety Tips Before You Arrive</h3>
          <p>
            The Guadalupe River near New Braunfels is one of the most beautiful — and most popular — float
            destinations in Texas. To make the most of your day, wear water shoes (rocks can be slippery), bring
            reef-safe sunscreen, stay hydrated with plenty of water, and keep a close eye on children at all times.
            Life jackets are available and strongly encouraged for kids and weaker swimmers. Never tube under the
            influence, and always float with a buddy. If river levels change unexpectedly, our team will notify
            booked guests by email and phone.
          </p>

          <h3 className="font-heading text-xl font-bold text-foreground mt-8">Need Help With Your Waiver?</h3>
          <p>
            If the form above doesn't load, try refreshing the page or switching browsers (Chrome and Safari work
            best). For any questions about your reservation, your waiver, or planning your family getaway near
            New Braunfels, our team is happy to help. Call{" "}
            <a href="tel:877-577-7667" className="text-teal font-medium hover:underline">877-577-7667</a> or email{" "}
            <a href="mailto:info@sonsgetaways.com" className="text-teal font-medium hover:underline">info@sonsgetaways.com</a>{" "}
            — we're available 9am–7pm daily and can usually get you sorted in just a few minutes.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Waivers;
